<template>
  <div
    class="flex flex-col md:flex-row border-b-[1px] border-solid border-[#4c5658] text-[15px] text-[#828585] min-h-[60px] md:items-center py-4 md:py-0 gap-2"
  >
    <div class="md:flex-1">
      Email
    </div>
    <div class="flex gap-3 items-center">
      <div class="break-all">
        {{ email }}
      </div>
      <button
        type="button"
        class="text-accent-400 cursor-pointer p-4 pr-0 ml-auto"
        @click="changeEmail"
      >
        Edit
      </button>
    </div>
  </div>
  <set-password-modal
    v-if="setPasswordModalOpen"
    :modal-message="'You must set a password to change your email'"
    @closeModal="setPasswordModalOpen = false"
  />
  <change-email-modal
    v-if="changeEmailModalOpen"
    @closeModal="changeEmailModalOpen = false"
  />
</template>

<script>
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import SetPasswordModal from './SetPasswordModal.vue';
import ChangeEmailModal from './ChangeEmailModal.vue';

export default {
  components: {
    SetPasswordModal,
    ChangeEmailModal,
  },
  setup() {
    const store = useStore();
    const setPasswordModalOpen = ref(false);
    const changeEmailModalOpen = ref(false);

    const email = computed(() => store.getters['user/account/getEmail']);
    const hasPassword = computed(
      () => store.getters['user/account/getPasswordExist']
    );

    return {
      email,
      hasPassword,
      setPasswordModalOpen,
      changeEmailModalOpen,
    };
  },

  methods: {
    changeEmail() {
      if (this.hasPassword) {
        this.changeEmailModalOpen = true;
      } else {
        this.setPasswordModalOpen = true;
      }
    },
  },
};
</script>
